import { MapPoint } from '@solar-icons/react'
import { useTranslation } from 'react-i18next'
import { Link, useLocation } from 'react-router-dom'
import { useUserLocation } from '@/hooks/use-user-location'
import { toAuthUserDisplay } from '@/modules/auth/utils/auth-user-display'
import { useAppStore } from '@/store/use-app-store'
import { useAuthStore } from '@/store/use-auth-store'

export function AppMobileTopbar() {
  const { t } = useTranslation('play')
  const { pathname } = useLocation()
  const { requestLocation } = useUserLocation()
  const selectedCity = useAppStore((s) => s.selectedCity)
  const loggedIn = useAuthStore((s) => s.status === 'authenticated')
  const authUser = useAuthStore((s) => s.user)
  const user = toAuthUserDisplay(authUser)

  if (
    pathname.startsWith('/buscar') ||
    pathname.startsWith('/quadra') ||
    pathname.startsWith('/reserva') ||
    pathname.startsWith('/reservas') ||
    pathname.startsWith('/conta')
  ) {
    return null
  }

  return (
    <header className="flex h-14 shrink-0 items-center justify-between border-b border-border-default bg-bg-base px-5 md:hidden">
      <Link to="/" className="flex min-w-0 items-center gap-2">
        <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-lg bg-primary font-display text-sm font-bold text-primary-fg">
          P
        </span>
        <span className="truncate font-display text-lg font-bold tracking-tight text-text-primary">
          {t('brand.name')}
        </span>
      </Link>

      <div className="flex shrink-0 items-center gap-2">
        <button
          type="button"
          onClick={() => requestLocation()}
          className="flex h-9 cursor-pointer items-center gap-1.5 rounded-full bg-bg-muted px-2.5 text-xs font-semibold text-text-secondary"
          aria-label={t('topbar.updateLocation')}
        >
          <MapPoint className="h-3.5 w-3.5 text-primary" weight="Bold" />
          {selectedCity}
        </button>

        {loggedIn ? (
          <Link
            to="/conta"
            className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary font-display text-xs font-bold text-primary-fg"
            aria-label={t('nav.myAccount')}
          >
            {user.initials}
          </Link>
        ) : (
          <Link
            to="/entrar"
            className="flex h-9 items-center rounded-lg bg-ink px-3 text-xs font-semibold text-ink-fg"
          >
            {t('nav.signIn')}
          </Link>
        )}
      </div>
    </header>
  )
}
